import Base from './Base'
import { STATUS_CODE } from '@/utils/constants'

class CommonService extends Base {
  findNotice(query) {
    return this.post('notice/query', query, { noEmpty: true })
  }

  readNotice(postData) {
    return this.post('notice/update', postData)
  }

  getSystemVersion() {
    return this.get('account/get_app_version')
  }

  /**
   *
   * @param {String} type lyric | track | image |
   * @param {File} file
   * @param {Object} [data] 额外传输的数据
   * @param {Object} options 直接传给 axios
   */
  upload(type, file, data, options) {
    const formData = new FormData()
    formData.append('file', file)
    if (data && typeof data === 'object') {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const element = data[key]
          formData.append(key, element)
        }
      }
    }

    return this.axios.post(`/action/upload?type=${type}`, formData, options).then(resp => {
      const respData = resp.data

      if (respData.code !== STATUS_CODE.SUCCESS) {
        return Promise.reject(new Error(respData.msg))
      }

      return Promise.resolve(respData.data)
    })
  }

  getTranscode(url) {
    return this.get(url)
  }

  getAiseeUrl(postData) {
    return this.post('common/get_aisee', postData)
  }

  transComplexFont(data) {
    return this.post('transform/traditional_to_simple_chinese', data)
  }

  getLyricText(url) {
    return this.axios.get(url)
  }

  findMarkdown(query) {
    return this.post('common/query_markdown_list', query)
  }

  saveMarkdown(postData) {
    return this.post('common/save_markdown', postData)
  }
}

export default new CommonService()
